import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/special-task`;

const getAdminSpecialTasks = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(API_URL + (queryString ? `?${queryString}` : ''));
};

const getAdminSpecialTask = async (id) => {
    return await axios.get(`${API_URL}/${id}`);
};

const addAdminSpecialTask = async (data) => {
    return await axios.post(API_URL, data);
};

const editAdminSpecialTask = async (id, data) => {
    return await axios.put(`${API_URL}/${id}`, data);
};

const deleteAdminSpecialTask = async (id) => {
    return await axios.delete(`${API_URL}/${id}`);
};

const AdminSpecialTaskService = {
    getAdminSpecialTasks,
    getAdminSpecialTask,
    addAdminSpecialTask,
    editAdminSpecialTask,
    deleteAdminSpecialTask
};

export default AdminSpecialTaskService;
